import { useQuery } from '@tanstack/react-query';
import { getAllStates } from '@uplift/api';
import { State } from '@uplift/types';

type StateList = {
  states: State[];
  availableStates: State[];
};

const defaultStateList: StateList = {
  states: [],
  availableStates: []
};

export const useStates = (suspense = false): StateList => {
  const { data = defaultStateList } = useQuery({
    queryKey: [ 'all-states' ],
    queryFn: async () => {
      const result = await getAllStates();

      const states = result.data.sort((a, b) => a.fullName.localeCompare(b.fullName));
      const availableStates = states.filter(x => x.available);

      return { states, availableStates };
    },
    refetchOnMount: false,
    suspense: suspense,
  });

  return data;
};
